export default __webpack_public_path__ + "static/media/appicon.acad0cd7.png";